.lead-sidebar-header {
    display: flex;
    justify-content: space-between;
    box-sizing: border-box;
    align-items: center;
    padding: 16px;
    height: 50px;
}

.lead-sidebar-header--collapsed {
    justify-content: center;
    border-bottom: none;
}
